import { useTranslations } from '@vocab/react';
import { Badge, Heading, Inline, Stack, Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

export const Intro = () => {
  const { t } = useTranslations(translations);
  return (
    <Stack space="medium">
      <Inline space="small" align="left">
        <Heading level="2">{t('intro-heading')}</Heading>
        <Badge tone="promote">{t('badge-text')}</Badge>
      </Inline>
      <Text>{t('intro-text')}</Text>
    </Stack>
  );
};
